import React, { useState, useEffect } from "react";
import { Table, Select, Button, Layout } from "antd";
import {
  getDomainBillable,
} from "./services/Endpoints";
import { AuthData, ComponentProps, DomainBillable, Domains } from "./type/Data";
import "./css/css.css";

const { Option } = Select;


const DataTable: React.FC<ComponentProps> = ({
  username,
  password,
  authData,
  domains,
  onBack,
}) => {
//   const [domains, setData] = useState<Domains[]>();
  const [billableDomain, setBillableDomain] = useState<DomainBillable[]>();
  const [domainNames, setDomainNames] = useState<string[]>([]);
  const [selectedCustomer, setSelectedCustomer] = useState<
    string | undefined
  >();
  const [selectedMonth, setSelectedMonth] = useState<number | undefined>();
  const [columns, setColumns] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);

    fetchData(); // Call the async function immediately
  }, []);

  const fetchDomainData = async (
    domainResp: Domains[]
  ): Promise<DomainBillable[]> => {
    const promises = domainResp.map(async (item) => {
      const response = await getDomainBillable(
        item.domain,
        authData
      );
      return response[0];
    });

    const billableList: DomainBillable[] = await Promise.all(promises);
    return billableList;
  };

  const fetchData = async () => {
    try {
    //   const domainsResp: Domains[] = await getDomains(authData);
      // const billableData = await getDomainBillable("", authData);

      const billableList: DomainBillable[] = await fetchDomainData(domains);

      setBillableDomain(billableList);

      const uniqueCustomers = Array.from(
        new Set(domains.map((item) => item.description))
      );
      setDomainNames(uniqueCustomers);

      const filteredKeys = Object.keys(billableList[0]).filter(
        (key) => key !== "description" && key !== "domain"
      );
      const dynamicColumns = filteredKeys.map((i) => ({
        title: i.toUpperCase().replaceAll("_", " "), // Convert keys to uppercase and replace underscores with spaces
        dataIndex: i.replaceAll("-", "_"),
        key: i.replaceAll("-", "_"),
        align: "center",
      }));

      const columns = [
        {
          title: "Description",
          dataIndex: "description",
          key: "description",
          fixed: "left",
          width: 250,
          sticky: true,
        },
        {
          title: "DOMAIN",
          dataIndex: "domain",
          key: "domain",
          fixed: "left",
          width: 200,
          sticky: true,
        },
        ...dynamicColumns,
      ];

      setColumns(columns);
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const scroll = { x: 5000 };

  const handleClearFilters = () => {
    setSelectedCustomer(undefined);
    setSelectedMonth(undefined);
  };

  const handleCustomerChange = (value: string) => {
    setSelectedCustomer(value);
  };

  const handleMonthChange = (value: number) => {
    setSelectedMonth(value);
  };

  const filteredData = billableDomain?.filter((item) => {
    const customerFilter =
      !selectedCustomer || item.description === selectedCustomer;
    const monthFilter =
      !selectedMonth || item.active_calls_onnet_current === selectedMonth;
    return customerFilter && monthFilter;
  });

  return (
    <div className="data-table">
      <a>Customers </a>
      <Select
        defaultValue="All"
        placeholder="Select Customer"
        value={selectedCustomer}
        onChange={handleCustomerChange}
        style={{ width: "300px" }}
      >
        <Option value={undefined}>All</Option>
        {domainNames.map((names) => (
          <Option key={names} value={names}>
            {names}
          </Option>
        ))}
      </Select>
      {/* <a> Date </a>
      <Select placeholder="Select Month" onChange={handleMonthChange}>
        <Option value="January">January</Option>
        <Option value="February">February</Option>
      </Select> */}
      <Button danger onClick={handleClearFilters}>Clear Filters</Button>
      {/* <Button onClick={onBack}>Back</Button> */}
      {/* <div className="table-container"> */}
      <div
        className="table-container"
        style={{ paddingTop: 20, paddingBottom: 64 }}
      >
        <Table
          // <Domains>
          dataSource={filteredData}
          columns={columns}
          bordered
          scroll={scroll}
          loading={loading}
          //   sticky={true}
        />
      </div>
    </div>
  );
};

export default DataTable;
